/* eslint @typescript-eslint/explicit-function-return-type: off */
export const listPagePath = (projectId, locale) =>
  `/projects/${projectId}/spreadsheet_report_configs${
    locale ? `?locale=${locale}` : ''
  }`;
export const newPagePath = (projectId, queryParamsString) =>
  `/projects/${projectId}/spreadsheet_report_configs/new${
    queryParamsString ? `?${queryParamsString}` : ''
  }`;
export const editPagePath = (
  projectId,
  spreadsheetReportConfigId,
  queryParamsString
) =>
  `/projects/${projectId}/spreadsheet_report_configs/${spreadsheetReportConfigId}/edit?${queryParamsString}`;

export const indexPath = (projectId) =>
  `/v1/projects/${projectId}/spreadsheet_report_configs`;
export const createPath = indexPath;
export const detailsPath = (projectId, spreadsheetReportConfigId) =>
  `${indexPath(projectId)}/${spreadsheetReportConfigId}`;
export const updatePath = (projectId, spreadsheetReportConfigId) =>
  `${indexPath(projectId)}/${spreadsheetReportConfigId}`;
export const connectSpreadsheetPath = (projectId, returnUrl) => {
  const baseUrl = `/oauth/google/redirect?channel=google_sheets&project_id=${projectId}`;
  if (!returnUrl) return baseUrl;
  return `${baseUrl}&return_url=${encodeURIComponent(returnUrl)}`;
};
export const getGoogleProfilePath = () => `/v1/google_sheets/sheets/token`;
export const getSheetListBySpreadsheetIdPath = () =>
  `/v1/google_sheets/sheets/list_sheets`;
export const getPanelPreviewDataPath = (projectId, locale) =>
  `/v1/projects/${projectId}/spreadsheet_report_previews${
    locale ? `?locale=${locale}` : ''
  }`;
export const clearGoogleProfilePath = (projectId) =>
  `/v1/google_sheets/sheets/clear_tokens?project_id=${projectId}`;
export const importSpreadsheetConfigCandidatesPath = () =>
  `/v1/spreadsheet_report_config_imports`;
